<template>
  <div class="dashboard">
		<p>総取引額<span>¥000,000</span></p>
		<div class="chart-part">
			<VueApexCharts width="800" type="bar" :options="options" :series="series"></VueApexCharts>
			<div class="chart-button">
				<a>
					<img src="@/assets/images/prev.svg" />
				</a>
				<a>
					<img src="@/assets/images/next.svg" />
				</a>
			</div>
		</div>
		<div class="activity">
			<p>アクティビティ</p>
			<div class="inner">
				<b-table-simple>
					<b-tbody>
						<b-tr>
							<b-td>2019/6/25  13:50:10</b-td>
							<b-td>ログイン</b-td>
						</b-tr>
						<b-tr>
							<b-td>2019/6/25  13:50:10</b-td>
							<b-td>ログイン</b-td>
						</b-tr>
						<b-tr>
							<b-td>2019/6/25  13:50:10</b-td>
							<b-td>ログイン</b-td>
						</b-tr>
						<b-tr>
							<b-td>2019/6/25  13:50:10</b-td>
							<b-td>ログイン</b-td>
						</b-tr>
						<b-tr>
							<b-td>2019/6/25  13:50:10</b-td>
							<b-td>ログイン</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>
		</div>
	</div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  methods: {
  },
  data () {
    return {
			options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: ['2019/1', '2019/2', '2019/3', '2019/4', '2019/5', '2019/6']
        }
      },
      series: [{
        name: '',
        data: [120000, 270000, 100000, 100000, 60000, 260000]
      }]
    }
  },
  components: {
		VueApexCharts
  },
  mounted () {
	}
}
</script>
